import axios from 'axios';
import Multiselect from 'vue-multiselect';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import showConfirmation from '@waypoint/vue-confirmation';
import showAlert from '@waypoint/vue-alert';
import moment from 'moment';

import Container from 'typedi';
import SimpleMap from '@/components/global/simple-map/SimpleMap.vue';
import BuscadorDirecciones from '@/components/global/buscador-direcciones/buscador-direcciones.vue';
import GoogleMapsApiLoader from 'google-maps-api-loader';
import draggable from 'vuedraggable';

import routesEscl from '@/locales/es-CL/routes.json';
import routesEsmx from '@/locales/es-MX/routes.json';
import routesEsco from '@/locales/es-CO/routes.json';
import routesEnus from '@/locales/en-US/routes.json';

export default {
  name: 'RouteBuilder',
  components: {
    draggable,
    Multiselect,
    VueCtkDateTimePicker,
    SimpleMap,
    BuscadorDirecciones,
    GoogleMapsApiLoader,
  },
  props: {
    routeId: {
      type: String,
      default: null,
    },
  },
  i18n: {
    messages: {
      'es-CL': { routes: routesEscl },
      'es-MX': { routes: routesEsmx },
      'es-CO': { routes: routesEsco },
      'en-US': { routes: routesEnus },
    },
  },
  data() {
    return {
      form: this.setForm(),
      trips: [],
      routeInfo: null,
      destinations: [],
      launched: false,
      temporalSpotRequired: false,
      temporalSpotPath: null,
      isTemporalSpotBusy: false,
      spotDefinitiveChecked: false,
      originAddressStreet: null,
      destinationAddressStreet: null,
      spotTypeList: [],
      spotTypeSelected: null,
      countryList: [],
      countrySelected: null,
      businessList: [],
      businessSelected: null,
      spotForm: {
        address: {
          city: null,
          postalCode: null,
          state: null,
          street: '',
          lat: null,
          lon: null,
          country: {
            id: null,
          },
        },
        category: null,
        comments: null,
        contacts: [],
        description: null,
        legalNumber: null,
        legalName: null,
        name: null,
        schedule: [],
        type: 'Temporal',
        zone: [],
      },
      gapi: null,
      isRouteEditable: false,
      requireSortTrip: false,
      sortingTrips: false,
      routeState: null,
    };
  },
  async created() {
    this.launched = true;

    GoogleMapsApiLoader({
      libraries: ['places', 'marker'],
      apiKey: this.$store.getters.apiKey,
    }).then((google) => {
      this.gapi = google;
    });
    await this.creationSteps();

    if (
      this.routeInfo &&
      (this.routeInfo.state == 'PARTIALLYASSIGNED' ||
        this.routeInfo.state == 'ASSIGNED' ||
        this.routeInfo.state == 'ONGOING')
    ) {
      this.isRouteEditable = false;
    } else {
      this.isRouteEditable = true;
    }
    this.newSpotActivated(this.form.origin, 'origin');
    this.launched = false;
    //this.getRouteInfo();
  },
  methods: {
    editTrip(trip) {
      this.$router.push({
        name: 'TripBuilder',
        params: { tripId: trip.id.toString(), originId: trip.origin.id, currentRoute: this.routeInfo },
      });
    },
    async creationSteps() {
      localStorage.removeItem('routeBuilderRouteId');
      localStorage.removeItem('routeBuilderTripId');
      localStorage.removeItem('routeBuilderActivityId');
      localStorage.removeItem('routeBuilderDocumentId');
      localStorage.removeItem('routeBuilderItemId');
      if (this.routeId) {
        localStorage.setItem('routeBuilderRouteId', this.routeId);
      }
      this.form = this.setForm();
      await this.getDestinations();
      await this.getSpotType();
      await this.getCountryList();
      if (this.routeId) {
        await this.getRouteInfo();
        //await this.removeGhostTrip();
        this.form = this.setForm();
      }
      this.launched = false;
    },
    removeGhostTrip() {
      if (this.routeInfo.destination !== undefined && this.trips[this.trips.length - 1] !== undefined) {
        if (this.routeInfo.destination.id === this.trips[this.trips.length - 1].destination.id) {
          this.trips.splice(this.trips.length - 1, 1);
        }
      }
    },
    getTripName(id) {
      const trip = this.routeInfo.trips.find((trip) => trip.id === id);
      if (trip && this.destinations.filter((destination) => destination.id === trip.destination.id).length > 0) {
        return this.destinations.find((destination) => destination.id === trip.destination.id).name;
      } else {
        return id;
      }
    },
    async getRouteInfo() {
      this.trips = [];
      try {
        console.log(this.routeId);
        const response = await axios.get(this.$store.getters.urlAPI + '/route/' + this.routeId, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        this.routeInfo = response.data.data;

        localStorage.setItem('routeSelectedLoadTime', this.routeInfo.loadTime);
        localStorage.setItem('routeSelectedUnloadTime', this.routeInfo.unloadTime);
        console.log('PROBANDO INFO RUTA ', this.routeInfo);
        this.trips = this.routeInfo.trips
          ? this.routeInfo.trips.sort((a, b) => new Date(a.endDate).getTime() - new Date(b.endDate).getTime())
          : [];
        this.routeState = this.routeInfo.state;
      } catch (e) {
        console.log(e);
        this.routeInfo = null;
        this.trips = [];
      }
    },
    async getDestinations() {
      try {
        const response = await axios.get(`${this.$store.getters.urlAPI}/api/spot/temporal?withAllTemporal=false`, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        this.destinations = response.data.data;
        this.setDestinationsAddressStreet();
      } catch (e) {
        this.destinations = [];
      }
    },
    /**
     * Metodo que obtiene la calle de los destinos.
     */
    setDestinationsAddressStreet() {
      this.destinations.forEach((destination) => {
        destination.addressStreet = destination.address.street;
      });
    },
    setForm() {
      return {
        origin: this.routeInfo ? this.destinations.find((d) => d.id === this.routeInfo.origin.id) : null,
        startTime: this.routeInfo ? moment(this.routeInfo.startDate).format('YYYY-MM-DD HH:mm:ss') : '',
        loadTime: this.routeInfo && this.routeInfo.loadTime ? String(Number(this.routeInfo.loadTime) / 60) : '',
        unloadTime: this.routeInfo && this.routeInfo.unloadTime ? String(Number(this.routeInfo.unloadTime) / 60) : '',
        name: this.routeInfo && this.routeInfo.name ? this.routeInfo.name : '',
      };
    },

    secondsToTimeString(segundos) {
      let secs = Math.round(segundos);
      let hours = Math.floor(secs / (60 * 60));
      let divisor_for_minutes = secs % (60 * 60);
      let minutes = Math.floor(divisor_for_minutes / 60);

      let divisor_for_seconds = divisor_for_minutes % 60;
      let seconds = Math.ceil(divisor_for_seconds);
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(
        2,
        '0',
      )}`;
    },
    timeStringToSeconds(timeString) {
      let values = timeString.split(':');
      if (values.length === 3) {
        let amount = Number(values[2]);
        amount += Number(values[1]) * 60;
        amount += Number(values[0]) * 60 * 60;
        return amount;
      } else {
        return 0;
      }
    },
    async save() {
      this.launched = true;
      try {
        if (this.validation()) {
          const body = {
            origin: {
              id: this.form.origin.id,
            },
            startDate: new Date(this.form.startTime).getTime(),
            loadTime: Number(this.form.loadTime) * 60,
            unloadTime: Number(this.form.unloadTime) * 60,
            name: this.form.name.trim(),
          };
          if (!this.routeId) {
            const apiKey = Container.get('apiKey');
            const response = await axios.post(`${this.$store.getters.urlAPI}/route`, body, {
              headers: {
                'id-client': this.$store.getters.clientId,
                Authorization: `Bearer ${this.$store.getters.accessToken}`,
                'x-api-key': apiKey,
              },
            });
            const id = response.data.data.id;
            console.log("Respuesta de rutas id ", id);
            showAlert(
              this.$t('routes.routeBuilder.modals.tituloExito'),
              this.$t('routes.routeBuilder.modals.mensajeExitoCreacion'),
              'success',
              () => {
                this.rechargePageWithId(id);
              },
              undefined,
              this.$t('common.cruds.aceptar'),
            );
          } else {
            body.id = Number(this.routeId);
            await axios.patch(`${this.$store.getters.urlAPI}/route/${this.routeId}`, body, {
              headers: {
                'id-client': this.$store.getters.clientId,
                Authorization: `Bearer ${this.$store.getters.accessToken}`,
              },
            });
            await this.invalidateCache();
            await this.getRouteInfo();
            //await this.removeGhostTrip();
            this.form = this.setForm();
            showAlert(
              this.$t('routes.routeBuilder.modals.tituloExito'),
              this.$t('routes.routeBuilder.modals.mensajeExitoActualizacion'),
              'success',
              undefined,
              undefined,
              this.$t('common.cruds.aceptar'),
            );
            this.launched = false;
          }
        } else {
          this.launched = false;
        }
      } catch (e) {
        this.launched = false;
        showAlert(
          this.$t('routes.routeBuilder.modals.tituloError'),
          this.$t('routes.routeBuilder.modals.mensajeError'),
          'error',
          undefined,
          undefined,
          this.$t('common.cruds.aceptar'),
        );
      }
    },
    rechargePageWithId(id){
      this.$router.push({ path: '/routeBuilder/' + id });
    },
    async invalidateCache() {
      await axios.get(this.$store.getters.urlAPI + '/route/invalidate', {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      });
    },
    clearSpotDataDetail() {
      this.spotForm.name = null;
      this.spotForm.legalName = null;
      this.spotForm.legalNumber = null;
      this.spotForm.type = null;
    },
    validationSpot() {
      if (this.spotDefinitiveChecked) {
        return (
          this.validateSpotAddress() &&
          this.validateSpotCountry() &&
          this.validateSpotState() &&
          this.validateSpotCity() &&
          this.validateSpotName() &&
          this.validateSpotType() &&
          this.validateSpotLegalNumber()
        );
      } else {
        return (
          this.validateSpotAddress() &&
          this.validateSpotCountry() &&
          this.validateSpotState() &&
          this.validateSpotCity()
        );
      }
    },
    validateSpotAddress() {
      const result = this.spotForm.address.street !== '';
      if (result) {
        return true;
      } else {
        this.showPopover('address');
        return false;
      }
    },
    validateSpotCountry() {
      const result = this.countrySelected !== null;
      if (result) {
        return true;
      } else {
        this.showPopover('country');
        return false;
      }
    },
    validateSpotState() {
      const result = this.spotForm.address.state !== null;
      if (result) {
        return true;
      } else {
        this.showPopover('state');
        return false;
      }
    },
    validateSpotCity() {
      const result = this.spotForm.address.city !== null;
      if (result) {
        return true;
      } else {
        this.showPopover('city');
        return false;
      }
    },
    validateSpotName() {
      const result = this.spotForm.name !== null;
      if (result) {
        return true;
      } else {
        this.showPopover('spotName');
        return false;
      }
    },
    validateSpotType() {
      const result = this.spotTypeSelected !== null;
      if (result) {
        return true;
      } else {
        this.showPopover('spotName');
        return false;
      }
    },
    validateSpotLegalNumber() {
      const result = this.spotForm.legalNumber !== null;
      if (result) {
        return true;
      } else {
        this.showPopover('spotId');
        return false;
      }
    },
    validation() {
      return (
        this.validateRouteName() &&
        this.validateOrigin() &&
        this.validateRouteStartTime() &&
        this.validateLoadTime() &&
        this.validateUnloadTime()
      );
    },
    validateLoadTime() {
      const result = this.validateTime(this.form.loadTime);
      if (result) {
        return true;
      } else {
        this.showPopover('fldLoadTime');
        return false;
      }
    },
    validateUnloadTime() {
      const result = this.validateTime(this.form.unloadTime);
      if (result) {
        return true;
      } else {
        this.showPopover('fldUnloadTime');
        return false;
      }
    },
    validateRouteStartTime() {
      if (this.form.startTime && this.form.startTime.trim().length) {
        const re = /^\d{4}-(0[1-9]|1[0-2])-([0-2]\d|3[01]) (0\d|1\d|2[0-3]):[0-5]\d:[0-5]\d$/;
        return re.test(this.form.startTime.trim());
      }
      this.showPopover('fldRouteStartTime');
      return false;
    },
    validateOrigin() {
      if (this.form.origin) {
        return this.destinations.filter((d) => d.id == this.form.origin.id).length > 0;
      }
      this.showPopover('fldOrigin');
      return false;
    },
    validateRouteName() {
      if (this.form.name && this.form.name.trim().length && this.form.name.trim().length <= 250) {
        return true;
      }
      this.showPopover('fldName');
      return false;
    },
    validateTime(time) {
      if (time.trim().length) {
        if (!isNaN(time) && Number(time) >= 0 && Number(time) <= 1440) {
          return true;
        }
      } else {
        return true;
      }
      return false;
    },
    queryRemoval(id) {
      showConfirmation(
        this.$t('routes.routeBuilder.modals.tituloConfirmacion'),
        this.$t('routes.routeBuilder.modals.confirmacionEliminar'),
        () => {
          this.removeTrip(id);
        },
        this.$t('common.cruds.aceptar'),
        this.$t('common.cruds.cerrar'),
      );
    },
    addTrip() {
      if (this.routeId) {
        if (this.trips.length == 0) {
          this.$router.push({
            name: 'TripBuilderNotId',
            params: { originId: this.form.origin.id, currentRoute: this.routeInfo },
          });
        } else {
          this.$router.push({
            name: 'TripBuilderNotId',
            params: { originId: this.trips[this.trips.length - 1].destination.id, currentRoute: this.routeInfo },
          });
        }
      } else {
        showConfirmation(
          this.$t('routes.routeBuilder.modals.tituloConfirmacion'),
          this.$t('routes.routeBuilder.modals.confirmacionGuardar'),
          () => {
            this.save();
          },
          this.$t('common.cruds.aceptar'),
          this.$t('common.cruds.cerrar'),
        );
      }
    },
    showPopover(id) {
      const wrongClass = 'wrong-input';
      this.$root.$emit('bv::show::popover', id);
      const multiselect = document.querySelector(`#${id} .multiselect`);
      if (multiselect) {
        multiselect.classList.add(wrongClass);
        return;
      }
      if (document.getElementById(id)) {
        document.getElementById(id).classList.add(wrongClass);
      }
    },
    hidePopover(id) {
      const wrongClass = 'wrong-input';
      this.$root.$emit('bv::hide::popover', id);
      const multiselect = document.querySelector(`#${id} .multiselect`);
      if (multiselect) {
        multiselect.classList.remove(wrongClass);
        return;
      }
    },

    async removeTrip(id) {
      this.trips = this.trips.filter((trip) => trip.id !== id);
      await axios.delete(this.$store.getters.urlAPI + '/trip/' + id, {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      });
      await this.invalidateCache();
    },
    checkFormDiferences() {
      const currentForm = this.form;
      const originalForm = this.setForm();
      const keys = Object.keys(currentForm);
      for (const key of keys) {
        if (currentForm[key] !== originalForm[key]) {
          if (typeof currentForm[key] === 'object') {
            if (JSON.stringify(currentForm[key]) !== JSON.stringify(originalForm[key])) {
              console.log(currentForm[key], originalForm[key], key);
              return true;
            }
          } else {
            console.log(currentForm[key], originalForm[key], key);
            return true;
          }
        }
      }
      return false;
    },
    newSpotActivated(spot, path) {
      if (spot !== null && spot.id === -1) {
        this.temporalSpotPath = path;
        this.temporalSpotRequired = true;
      } else if (spot !== null) {
        if (path === 'origin') {
          this.originAddressStreet = spot.addressStreet;
        }
      } else if (spot === null) {
        if (path === 'origin') {
          this.originAddressStreet = null;
        }
      }
    },
    checkClientSpot() {
      this.spotForm.legalName = null;
      this.spotForm.legalNumber = null;

      const client = this.$store.getters.client;

      this.spotForm.type = this.spotTypeSelected;

      if (this.spotForm.type === 'Sede propia') {
        this.spotForm.legalNumber = client.legalNumber;
        this.spotForm.legalName = client.legalName;
      } else if (this.spotForm.type === 'Cliente') {
        this.spotForm.legalNumber = null;
        this.spotForm.legalName = null;
        this.businessSelected = null;
        this.getBusinessList();
      } else if (this.spotForm.type === 'Otro') {
        this.spotForm.legalName = client.legalName;
      }
    },
    setBusiness() {
      this.spotForm.legalNumber = this.businessSelected.legalNumber;
      this.spotForm.legalName = this.businessSelected.legalName;
    },
    async getBusinessList() {
      this.isLoadingBusiness = true;
      var url = `${this.$store.getters.urlAPI}/api/business/`;
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      try {
        const response = await axios.get(url, config);
        this.businessList = response.data.data;
      } catch (error) {
        console.log(`${error}, Ha ocurrido un error.`);
      }
    },
    async createTemporalSpot() {
      this.isTemporalSpotBusy = true;
      let spot = null;
      if (this.validationSpot()) {
        await this.prepareSpotBody();
        spot = await this.createSpot();
        if (this.spotForm.type === 'Cliente' && spot !== null) {
          await this.createSpotBusiness(spot.id);
        }

        if (spot !== null) {
          if (this.temporalSpotPath === 'origin') {
            this.destinations.push(spot);
            spot.addressStreet = spot.address.street;
            this.form.origin = spot;
            this.originAddressStreet = this.form.origin.addressStreet;
          }
        }
      }
      this.isTemporalSpotBusy = false;
      if (spot !== null) {
        this.closeModal('create-temporal-spot-modal');
        showAlert(
          this.$t('routes.routeBuilder.modals.tituloExito'),
          this.$t('routes.routeBuilder.modals.mensajeExitoCreacionSpot'),
          'success',
          undefined,
          undefined,
          this.$t('common.cruds.aceptar'),
        );
      }
    },
    async createSpot() {
      try {
        const url = `${this.$store.getters.urlAPI}/api/spot`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.post(url, this.spotForm, config);
        if (response.data.status) {
          return response.data.data;
        }
      } catch (error) {
        this.isSaving = false;

        if (error.response.status === 500) {
          var rawJson = '' + error.response.data;

          //Se obtiene la hora en que ocurre el error.
          const eventTime = moment(new Date().getTime()).format('YYYY-MM-DD HH:mm:ss');

          //Se controla error en caso de que el nombre de la ubicacion ya exista.
          if (
            rawJson.includes(
              'ERROR: duplicate key value violates unique constraint "name_id_client_deleted_at_null_idx"',
            )
          ) {
            showAlert(
              'Error: ' + this.$t('routes.routeBuilder.modals.nameSpot'),
              this.$t('routes.routeBuilder.modals.spotDuplicated') + ' [' + eventTime + ']',
              'error',
            );
          }

          //Cualquier error no controlado
          showAlert(
            'Error ' + error.response.status,
            this.$t('routes.routeBuilder.modals.spotUnexpectedError') + ' [' + eventTime + ']',
            'error',
          );
        }
        return null;
      }
    },
    async createSpotBusiness(spotId) {
      try {
        const body = {
          idSpot: spotId,
          idBusiness: this.businessSelected.id,
          idClient: this.$store.getters.clientId,
        };
        const url = `${this.$store.getters.urlAPI}/api/spot/spotBusiness`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.post(url, body, config);
        console.log(response.data.status);
      } catch (error) {
        console.log('error', error);
      }
    },
    async prepareSpotBody() {
      const now = new Date().getTime();
      const actualDate = new Date(now).toISOString().split('T')[0];
      var counterTemporalSpot = 0;
      this.destinations.forEach((destination) => {
        if (destination.type === 'Temporal') {
          counterTemporalSpot++;
        }
      });
      this.spotForm.zone = [
        {
          lat: this.spotForm.address.lat,
          lon: this.spotForm.address.lon,
          radio: 100,
        },
      ];
      let completeAdress =
        this.spotForm.address.street + ', ' + this.spotForm.address.city + ', ' + this.spotForm.address.state;
      console.log('calle', completeAdress);
      if (!this.spotDefinitiveChecked) {
        this.spotForm.name = `${completeAdress}_${actualDate}_${counterTemporalSpot}`;
        this.spotForm.legalName = `${completeAdress}_${actualDate}_${counterTemporalSpot}`;
        this.spotForm.legalNumber = `${completeAdress}_${actualDate}_${counterTemporalSpot}`;
        this.spotForm.type = 'Temporal';
      }
      console.log('probando spots temporales crear', this.spotForm);
    },
    async getSpotType() {
      const url = `${this.$store.getters.urlAPI}/api/enum?type=spot_type`;
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      try {
        const response = await axios.get(url, config);
        this.spotTypeList = response.data.data;

        const index = this.spotTypeList.indexOf('Temporal');
        if (index > -1) {
          this.spotTypeList.splice(index, 1);
        }
      } catch (error) {
        console.log(`${error}, Ha ocurrido un error.`);
      }
    },
    async getCountryList() {
      var url = `${this.$store.getters.urlAPI}/api/country`;
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      const response = await axios.get(url, config);
      response.data.data.forEach((element) => {
        this.countryList.push({
          id: element.id,
          name: element.name,
          iso: element.iso,
        });
      });
      if (this.countryList.length > 0) {
        console.log('Listado de paises listo!');
        this.sortCountryList();
      } else {
        console.log('Listado de paises no listo. No se pueden crear ordenes!');
      }
    },
    sortCountryList() {
      this.countryList.sort(function (a, b) {
        if (a.name > b.name) {
          return 1;
        }
        if (a.name < b.name) {
          return -1;
        }
        // a y b son iguales.
        return 0;
      });
    },
    customForm(option) {
      if (option === 'state') {
        if (this.countrySelected !== null) {
          if (this.countrySelected.iso === 'CL') {
            return this.$t('routes.routeBuilder.modals.region');
          }

          if (this.countrySelected.iso === 'MX') {
            return this.$t('routes.routeBuilder.modals.delegation');
          }
        }
        return this.$t('routes.routeBuilder.modals.state');
      }
      if (option === 'city') {
        if (this.countrySelected !== null) {
          if (this.countrySelected.iso === 'CL') {
            return this.$t('routes.routeBuilder.modals.comuna');
          }

          if (this.countrySelected.iso === 'MX') {
            return this.$t('routes.routeBuilder.modals.colony');
          }
        }
        return this.$t('routes.routeBuilder.modals.city');
      }
    },
    async receiveAddressInformation(addressInfo) {
      if (addressInfo.streetName !== '') {
        console.log(addressInfo);
        this.countrySelected = addressInfo.iso.length === 0 ? '' : await this.getCountryByIso(addressInfo.iso);
        this.spotForm.address.city = addressInfo.city;
        this.spotForm.address.state = addressInfo.state;
        this.spotForm.address.street =
          addressInfo.number !== undefined ? addressInfo.streetName + ' ' + addressInfo.number : addressInfo.streetName;
        this.spotForm.address.lat = addressInfo.coordinates.lat;
        this.spotForm.address.lon = addressInfo.coordinates.lng;
        this.spotForm.address.country = {
          id: this.countrySelected.id,
        };
        const coordinates = [
          {
            position: {
              lat: this.spotForm.address.lat,
              lng: this.spotForm.address.lon,
            },
          },
        ];
        this.$refs.map.setSpot(coordinates);
        this.$refs.map.createGeoreference(true, 100);
      }
    },
    getCountryByIso(countryIso) {
      let countryMatched = null;
      this.countryList.forEach((element) => {
        if (countryIso === element.iso) {
          countryMatched = element;
        }
      });
      return countryMatched;
    },
    cleanSpotForm() {
      this.spotForm = {
        address: {
          city: null,
          postalCode: null,
          state: null,
          street: '',
          lat: null,
          lon: null,
          country: {
            id: null,
          },
        },
        category: null,
        comments: null,
        contacts: [],
        description: null,
        legalNumber: null,
        legalName: null,
        name: null,
        schedule: [],
        type: 'Temporal',
        zone: [],
      };
    },
    closeModal(id) {
      this.$bvModal.hide(id);
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    hideError(originalReference) {
      if (originalReference === this.errorReference) {
        this.errorReference = null;
      }
    },
    async sortTrips() {
      try {
        const body = [];
        const url = `${this.$store.getters.urlAPI}/route/${this.routeId}/reOrderTrips`;
        this.trips.forEach((trip) => {
          body.push(trip.id);
        });
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.post(url, body, config);
        console.log(response.data);
        showAlert(
          this.$t('routes.routeBuilder.modals.tituloExito'),
          this.$t('routes.routeBuilder.modals.mensajeExitoReordenViajes'),
          'success',
          () => {},
          undefined,
          this.$t('common.cruds.aceptar'),
        );
      } catch (error) {
        console.log('error', error);
        showAlert(
          this.$t('routes.routeBuilder.modals.tituloError'),
          this.$t('routes.routeBuilder.modals.mensajeError'),
          'error',
          undefined,
          undefined,
          this.$t('common.cruds.aceptar'),
        );
      }
    },
  },
  computed: {
    minDate() {
      //YYYY-MM-DD HH:MM:SS en 24 horas format
      var minDate = new Date();
      minDate.setDate(minDate.getDate() - 3);
      return minDate.toLocaleDateString('fr-ca') + ' ' + minDate.toLocaleTimeString('en-GB');
    },
    renderedOrigins() {
      return [
        {
          id: -1,
          name: this.$t('routes.routeBuilder.otros.crearNuevoOrigen'),
          addressStreet: null,
        },
        ...this.destinations,
      ];
    },
    renderedDestinations() {
      return [
        {
          id: null,
          name: this.$t('routes.routeBuilder.otros.destinoUltimoViaje'),
          addressStreet: null,
        },
        {
          id: -1,
          name: this.$t('routes.routeBuilder.otros.crearNuevoDestino'),
          addressStreet: null,
        },
        ...this.destinations,
      ];
    },
    renderedEndDate() {
      return this.routeInfo ? moment(this.routeInfo.endDate).format('YYYY-MM-DD HH:mm:ss') : '';
    },
  },
  beforeRouteLeave(to, from, next) {
    if (!this.launched && this.checkFormDiferences()) {
      const answer = window.confirm(this.$t('common.cruds.pendingChanges'));
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  watch: {
    routeId() {
      this.creationSteps();
    },
    temporalSpotRequired: function () {
      if (this.temporalSpotRequired) {
        this.cleanSpotForm();
        this.showModal('create-temporal-spot-modal');
        this.isTemporalSpotBusy = false;
        this.temporalSpotRequired = false;
      }
    },
    trips: async function () {
      if (this.requireSortTrip && this.routeState == 'NOTASSIGNED') {
        this.requireSortTrip = false;
        this.sortingTrips = true;
        await this.sortTrips();
        await this.getRouteInfo();
        this.sortingTrips = false;
      }
    },
  },
};
